/**
 * Utilities for generating obfuscated localStorage keys for legal alert dismissal state.
 */

const obfuscateLegalIdentifierString = (str: string): string => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash;
  }
  return Math.abs(hash).toString(36);
};

export const generateHashedLegalKey = (
  userId: string,
  brandId: string,
  analysisId: string,
  aiProvider: string,
): string => {
  const dataString = `${userId}_${brandId}_${analysisId}_${aiProvider}`;
  const hashedData = obfuscateLegalIdentifierString(dataString);
  return `yst_legal_alert_dismissed_${hashedData}`;
};
